export default __webpack_public_path__ + "static/img_desktop_6-64c2f233e798e2f0fc7fa6155d757f08.jpg";